@let noTableData = (dataSource?.length | async) === 0;

<div
  class="qt-data-table__container"
  cdkDropList
  [cdkDropListSortingDisabled]="tableConfig().dragSortingDisabled"
  [cdkDropListEnterPredicate]="canListBeDropped"
  (cdkDropListDropped)="dropped($event)"
  (cdkDropListEntered)="dragEntered()"
  (cdkDropListExited)="dragExited()">
  <div class="qt-data-table__wrapper" [style.flex-grow]="noTableData ? 0 : 1">
    <mat-table
      matSort
      [dataSource]="dataSource || []"
      [trackBy]="rowTrackByFn()"
      multiTemplateDataRows>
      <!-- COLUMNS -->
      <ng-container
        *ngFor="let column of columns(); trackBy: trackByColumns"
        [matColumnDef]="column.id"
        [sticky]="column.sticky ?? false"
        [stickyEnd]="column.stickyEnd ?? false">
        <mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          [disabled]="!column.sortable"
          [class.qt-data-table__cell--numeric]="column.numeric"
          [style.flex-basis.px]="column.minWidth"
          [style.min-width.px]="column.minWidth"
          [style.max-width.px]="column.maxWidth">
          <ng-container *ngIf="!headerDefMap.get(column.id)">
            {{ column | columnHeader }}
          </ng-container>
          <ng-template
            *ngIf="headerDefMap.get(column.id) as template"
            [ngTemplateOutlet]="template"
            [ngTemplateOutletContext]="{
              value: column,
            }"></ng-template>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let row"
          [class.qt-data-table__cell--numeric]="column.numeric"
          [style.flex-basis.px]="column.minWidth"
          [style.min-width.px]="column.minWidth"
          [style.max-width.px]="column.maxWidth"
          ><span class="w-100">
            @if (columnDefMap.has(column.id) === true) {
              <ng-template
                [ngTemplateOutlet]="columnDefMap.get(column.id)"
                [ngTemplateOutletContext]="{
                  row: row,
                  value: valueAccessorFn(row, column.id),
                  vals: column.vals,
                }"></ng-template>
            } @else if (
              !!column.format && formatDefMap.has(column.format) === true
            ) {
              <ng-template
                [ngTemplateOutlet]="formatDefMap.get(column.format)"
                [ngTemplateOutletContext]="{
                  row: row,
                  value: valueAccessorFn(row, column.id),
                  vals: column.vals,
                }"></ng-template>
            } @else {
              {{ valueAccessorFn(row, column.id) }}
            }
          </span>
        </mat-cell>
      </ng-container>
      <ng-container
        [matColumnDef]="selectId"
        *ngIf="!tableConfig().hideSelect"
        sticky>
        <mat-header-cell *matHeaderCellDef class="qt-data-table__select-cell">
          <mat-checkbox
            *ngIf="tableConfig().multiple"
            (change)="
              toggleAll(selection()); selectRow.emit(selection().selected)
            "
            [checked]="selection().hasValue() && isAllSelected(selection())"
            [indeterminate]="
              selection().hasValue() && !isAllSelected(selection())
            ">
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let row; let index"
          class="qt-data-table__select-cell"
          (click)="$event.stopPropagation()">
          <ng-container
            *ngIf="columnDefMap.has(selectId); else selectColumnDef">
            <ng-template
              [ngTemplateOutlet]="columnDefMap.get(selectId)"
              [ngTemplateOutletContext]="{
                row: row,
                checked: selection().isSelected(row),
                clickSelect: getClickSelected(selection, row),
              }"></ng-template>
          </ng-container>
          <ng-template #selectColumnDef>
            <mat-checkbox
              *ngIf="tableConfig().multiple; else singleSelect"
              [checked]="selection().isSelected(row)"
              (change)="
                toggle(selection(), row); selectRow.emit(selection().selected)
              ">
            </mat-checkbox>
            <ng-template #singleSelect>
              <mat-radio-button
                [name]="uid + '-radio-' + index"
                [checked]="selection().isSelected(row)"
                (change)="
                  toggle(selection(), row); selectRow.emit(selection().selected)
                ">
              </mat-radio-button>
            </ng-template>
          </ng-template>
        </mat-cell>
      </ng-container>
      <ng-container [matColumnDef]="actionId" stickyEnd>
        <mat-header-cell *matHeaderCellDef class="qt-data-table__icon-cell">
          <ng-template
            [ngTemplateOutlet]="headerDefMap.get(actionId)"
            [ngTemplateOutletContext]="{ value: actionId }"></ng-template>
          <ng-container *ngIf="!headerDefMap.get(actionId)"></ng-container>
        </mat-header-cell>

        <ng-container *ngIf="!menuColumnDef(); else menuColumnDefTemp">
          <mat-cell
            *matCellDef="let row"
            class="qt-data-table__icon-cell qt-data-table__numeric"
            (click)="$event.stopPropagation()">
            <button
              *ngIf="tableConfig().menuButIcon && isNotGroupRow(0, row)"
              mat-icon-button
              [matMenuTriggerFor]="menu"
              [matMenuTriggerData]="{ row: row }"
              [disabled]="isStandalonePopout()">
              <mat-icon>more_vert</mat-icon>
            </button>
            <button
              *ngIf="
                tableConfig().menuButIcon && tableConfig().showDragIndicator
              "
              mat-icon-button>
              <mat-icon>drag_indicator</mat-icon>
            </button>
          </mat-cell>
        </ng-container>
        <ng-template #menuColumnDefTemp>
          <mat-cell
            *matCellDef="let row"
            class="qt-data-table__icon-cell qt-data-table__numeric"
            (click)="$event.stopPropagation()">
            @if (isNotGroupRow(0, row)) {
              <ng-template
                [ngTemplateOutlet]="columnDefMap.get(actionId)"
                [ngTemplateOutletContext]="{
                  row: row,
                }"></ng-template>
            }
          </mat-cell>
        </ng-template>
      </ng-container>

      <ng-container [matColumnDef]="expandId" sticky>
        <mat-header-cell
          *matHeaderCellDef
          class="qt-data-table__icon-cell"
          [style.paddingLeft]="'6px'">
        </mat-header-cell>
        <ng-container
          *ngIf="!columnDefMap.has(expandId); else expandColumnDefTemp">
          <mat-cell
            *matCellDef="let row"
            class="qt-data-table__icon-cell"
            (click)="toggle(details, row); $event.stopPropagation()"
            [style.paddingLeft]="'6px'">
            <button mat-icon-button>
              <mat-icon
                [@indicatorRotate]="
                  details.isSelected(row) ? 'expanded' : 'collapsed'
                "
                >keyboard_arrow_down
              </mat-icon>
            </button>
          </mat-cell>
        </ng-container>
        <ng-template #expandColumnDefTemp>
          <mat-cell
            *matCellDef="let row"
            class="qt-data-table__icon-cell"
            [style.paddingLeft]="'6px'"
            (click)="toggle(details, row); $event.stopPropagation()">
            <ng-template
              [ngTemplateOutlet]="columnDefMap.get(expandId)"
              [ngTemplateOutletContext]="{
                row: row,
                expanded: details.isSelected(row),
              }"></ng-template>
          </mat-cell>
        </ng-template>
      </ng-container>

      <ng-container [matColumnDef]="groupId" sticky>
        @let column = groupedByIdColumn();
        <mat-header-cell
          *matHeaderCellDef
          [style.flex-basis.px]="column?.minWidth ?? 100"
          [style.min-width.px]="column?.minWidth ?? 100"
          [style.max-width.px]="column?.maxWidth ?? 100">
          {{ 'GNR_GROUP_BY' | translate }}
        </mat-header-cell>
        <mat-cell
          *matCellDef="let row"
          [style.flex-basis.px]="column?.minWidth ?? 100"
          [style.min-width.px]="column?.minWidth ?? 100"
          [style.max-width.px]="column?.maxWidth ?? 100"
          (click)="toggleGroupByRow(row); $event.stopPropagation()">
          @if (isGroupRow(0, row)) {
            @if (isGroupingCollapsible()) {
              <button mat-icon-button>
                <mat-icon
                  [@indicatorRotate]="
                    isGroupRowExpanded(expandedGroupRow, row)
                      ? 'expanded'
                      : 'collapsed'
                  ">
                  keyboard_arrow_down
                </mat-icon>
              </button>
            }
            <!-- Total count of items in group -->
            <!-- <span> ({{ row.__totalGroupCount }}) </span> -->
            <!-- Value by grouped column -->
            @if (!!column && columnDefMap.has(column.id) === true) {
              <ng-template
                [ngTemplateOutlet]="columnDefMap.get(column.id)"
                [ngTemplateOutletContext]="{
                  row: row,
                  value: row.__groupBy,
                  vals: column.vals,
                }"></ng-template>
            } @else if (
              !!column &&
              !!column.format &&
              formatDefMap.has(column.format) === true
            ) {
              <ng-template
                [ngTemplateOutlet]="formatDefMap.get(column.format)"
                [ngTemplateOutletContext]="{
                  row: row,
                  value: row.__groupBy,
                  vals: column.vals,
                }"></ng-template>
            } @else {
              {{ row.__groupBy || ('GNR_UNGROUPED' | translate) }}
            }
          }
        </mat-cell>
      </ng-container>

      <!-- ROWS -->
      <mat-header-row
        [style.display]="tableConfig().hideHeaderRow ? 'none' : 'flex'"
        [attr.sticky]="tableConfig().isHeaderSticky"
        *matHeaderRowDef="columnsIds()"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: columnsIds(); when: isGroupRow"
        [class.qt-data-table__row--group-by]="isGroupedBy()"
        [class.qt-data-table__row--loading]="loading()"
        (click)="toggleGroupByRow(row); $event.stopPropagation()">
      </mat-row>
      <mat-row
        *matRowDef="let row; columns: columnsIds(); when: isNotGroupRow"
        (click)="
          rowClick.emit(row); rowEventClick.emit({ data: row, event: $event })
        "
        (dblclick)="rowDoubleClick.emit(row)"
        [class.qt-data-table__row--selected]="
          tableConfig().selectable && selection().isSelected(row)
        "
        [class.qt-data-table__row--clickable]="
          rowClick.observed || rowEventClick.observed
        "
        [class.qt-data-table__row--warning]="
          warningRowIds()?.has(row[itemKey()])
        "
        [class.qt-data-table__row--loading]="loading()"
        [qtDetailRow]="row"
        [qtDetailRowOpened]="
          details.isSelected(row) && tableConfig().displayDetailRow
        "
        [qtDetailRowTemplate]="detailsTemp"
        [ngStyle]="rowStylesCallback()(row)"
        [style.display]="
          isGroupRowExpanded(expandedGroupRow, row) ? 'none' : 'flex'
        "
        cdkDrag
        [cdkDragData]="
          tableConfig().selectable && tableConfig().multiple
            ? tableConfig().selectable && selection().selected
            : row
        "
        [cdkDragDisabled]="
          tableConfig().draggable
            ? tableConfig().selectable
              ? !(tableConfig().selectable && selection().isSelected(row))
              : false
            : true
        ">
        <ng-container
          *ngIf="
            tableConfig().multiple &&
            tableConfig().draggable &&
            tableConfig().selectable
          ">
          <div class="qt-data-table__item-drag-preview" *cdkDragPreview>
            {{
              selection().selected.length > 0 ? selection().selected.length : 1
            }}
          </div>
        </ng-container>

        <ng-container *ngIf="draggingPlaceholder() as placeholderTemplate">
          <ng-container *cdkDragPlaceholder>
            <ng-container
              *ngTemplateOutlet="placeholderTemplate"></ng-container>
          </ng-container>
        </ng-container>
      </mat-row>
    </mat-table>
  </div>

  <ng-template #detailsTemp let-row>
    @if (detailsTemplate()) {
      <div class="qt-data-table__details-wrapper">
        <ng-template
          [ngTemplateOutlet]="detailsTemplate()"
          [ngTemplateOutletContext]="{ row: row }"></ng-template>
      </div>
    }
  </ng-template>

  <div class="qt-data-table__loading" *ngIf="loading()">
    <qt-data-table-loading></qt-data-table-loading>
    <p class="qt-data-table__loading-description">
      {{ 'GNR_PLS_WAIT' | translate }}
    </p>
  </div>

  <ng-container *ngIf="!loading() && noTableData && !isDragPlaceholder">
    <ng-content select="qt-empty-state"></ng-content>
    <qt-table-empty-state
      *ngIf="!emptyState"
      [title]="'GNR_NO_DATA' | translate"
      [subtitle]="'GNR_NO_DATA_FULL' | translate">
      <mat-icon>info</mat-icon>
    </qt-table-empty-state>
  </ng-container>

  <ng-content select="mat-paginator"></ng-content>
</div>
